import { SessionProvider } from '@sdk/session/SessionContext';
import ScreenLoader from '@sdk/components/ui/ScreenLoader';

import { AnnouncementNotification } from '@web/announcements/AnnouncementNotification/AnnouncementNotification';
import { AnnouncementDashboardNotification } from '@web/announcements/types/AnnouncementDashboardNotification';
import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';

type Props = {
  notification: AnnouncementDashboardNotification;
  onClose: () => void;
};

export const AnnouncementNotificationModal = (props: Props) => {
  return (
    <QueryClientProvider>
      <SessionProvider loader={<ScreenLoader />}>
        <AnnouncementNotification {...props} />
      </SessionProvider>
    </QueryClientProvider>
  );
};
